import { graphql } from "@/lib/generated"

export const StreamsQuery = graphql(`
  query Streams($applicationId: UUID, $status: StreamStatus, $search: String, $limit: Int, $offset: Int, $after: String, $first: Int) {
    streams(applicationId: $applicationId, status: $status, search: $search, limit: $limit, offset: $offset, after: $after, first: $first) {
      nodes {
        id
        applicationId
        name
        status
        retentionDays
        createdAt
        application {
          id
          name
        }
      }
      pageInfo {
        total
        limit
        offset
        endCursor
        hasNextPage
      }
    }
  }
`)

export const StreamQuery = graphql(`
  query Stream($id: UUID!) {
    stream(id: $id) {
      id
      applicationId
      name
      status
      retentionDays
      createdAt
      application {
        id
        name
        uid
      }
      entries(limit: 50) {
        nodes {
          id
          sequence
          messageId
          eventType
          createdAt
        }
        pageInfo {
          total
        }
      }
      consumers(limit: 50) {
        nodes {
          id
          name
          cursorSequence
          createdAt
          updatedAt
        }
        pageInfo {
          total
        }
      }
      sinks(limit: 50) {
        nodes {
          id
          name
          sinkType
          config
          batchSize
          flushInterval
          cursorSequence
          status
          lastFlushedAt
          createdAt
        }
        pageInfo {
          total
        }
      }
    }
  }
`)

export const StreamEntriesQuery = graphql(`
  query StreamEntries($streamId: UUID!, $afterSequence: Int, $limit: Int) {
    streamEntries(streamId: $streamId, afterSequence: $afterSequence, limit: $limit) {
      nodes {
        id
        streamId
        sequence
        messageId
        eventType
        payload
        createdAt
        message {
          id
          eventType
        }
      }
      pageInfo {
        total
      }
    }
  }
`)

export const ConsumeStreamQuery = graphql(`
  query ConsumeStream($streamId: UUID!, $consumerName: String!, $limit: Int) {
    consumeStream(streamId: $streamId, consumerName: $consumerName, limit: $limit) {
      nodes {
        id
        sequence
        messageId
        eventType
        createdAt
      }
      pageInfo {
        total
      }
    }
  }
`)

export const CreateStreamMutation = graphql(`
  mutation CreateStream($input: CreateStreamInput!) {
    createStream(input: $input) {
      id
      name
      status
      retentionDays
      createdAt
    }
  }
`)

export const UpdateStreamMutation = graphql(`
  mutation UpdateStream($id: UUID!, $input: UpdateStreamInput!) {
    updateStream(id: $id, input: $input) {
      id
      name
      status
      retentionDays
      createdAt
    }
  }
`)

export const DeleteStreamMutation = graphql(`
  mutation DeleteStream($id: UUID!) {
    deleteStream(id: $id)
  }
`)

export const CreateStreamConsumerMutation = graphql(`
  mutation CreateStreamConsumer($input: CreateStreamConsumerInput!) {
    createStreamConsumer(input: $input) {
      id
      name
      cursorSequence
      createdAt
    }
  }
`)

export const DeleteStreamConsumerMutation = graphql(`
  mutation DeleteStreamConsumer($id: UUID!) {
    deleteStreamConsumer(id: $id)
  }
`)

export const AdvanceConsumerCursorMutation = graphql(`
  mutation AdvanceConsumerCursor($id: UUID!, $sequence: Int!) {
    advanceConsumerCursor(id: $id, sequence: $sequence) {
      id
      cursorSequence
      updatedAt
    }
  }
`)

export const CreateStreamSinkMutation = graphql(`
  mutation CreateStreamSink($input: CreateStreamSinkInput!) {
    createStreamSink(input: $input) {
      id
      name
      sinkType
      batchSize
      flushInterval
      status
      createdAt
    }
  }
`)

export const UpdateStreamSinkMutation = graphql(`
  mutation UpdateStreamSink($id: UUID!, $input: UpdateStreamSinkInput!) {
    updateStreamSink(id: $id, input: $input) {
      id
      name
      sinkType
      batchSize
      flushInterval
      status
      createdAt
    }
  }
`)

export const DeleteStreamSinkMutation = graphql(`
  mutation DeleteStreamSink($id: UUID!) {
    deleteStreamSink(id: $id)
  }
`)

export const StreamEntryAppendedSubscription = graphql(`
  subscription StreamEntryAppended($streamId: UUID!) {
    streamEntryAppended(streamId: $streamId) {
      id
      streamId
      sequence
      messageId
      eventType
      createdAt
    }
  }
`)
